export default "__VITE_ASSET__BOe$PawX__"